import SuspendGame from "./SuspendGame";
import PauseGame from "./PauseGame"
import ResumeGame from "./ResumeGame";
import SoundOff from "./SoundOff";
import SoundOn from "./SoundOn";
import UpdateBalance from "./UpdateBalance";
import ResetGame from "./ResetGame";
import Resize from "./Resize";
import DepositCanceled from "./DepositCanceled";
import DepositCompleted from "./DepositCompleted";
import OpenGameHistory from "./OpenGameHistory";
import ExitFullScreen from "./ExitFullScreen";
import OpenPaytable from "./OpenPaytable";
import OpenHelp from "./OpenHelp";
import CloseHelp from "./CloseHelp";
import ClosePaytable from "./ClosePaytable";
import SetLaunchUrl from "./SetLaunchUrl";
import SetGameConfig from "./SetGameConfig";

export default class GameEmitters {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    suspendGame() {
        return new SuspendGame(this.gb).exec();
    }

    pauseGame() {
        return new PauseGame(this.gb).exec();
    }

    resumeGame() {
        return new ResumeGame(this.gb).exec();
    }

    soundOff() {
        return new SoundOff(this.gb).exec();
    }

    soundOn() {
        return new SoundOn(this.gb).exec();
    }

    updateBalance(data) {
        return new UpdateBalance(this.gb).exec(data);
    }

    resetGame() {
        return new ResetGame(this.gb).exec();
    }

    resize(obj) {
        return new Resize(this.gb).exec(obj);
    }

    depositCanceled() {
        return new DepositCanceled(this.gb).exec();
    }

    depositCompleted() {
        return new DepositCompleted(this.gb).exec();
    }

    openGameHistory() {
        return new OpenGameHistory(this.gb).exec();
    }

    exitFullScreen() {
        return new ExitFullScreen(this.gb).exec();
    }

    openPaytable() {
        return new OpenPaytable(this.gb).exec();
    }

    closePaytable() {
        return new ClosePaytable(this.gb).exec();
    }

    openHelp() {
        return new OpenHelp(this.gb).exec();
    }

    closeHelp() {
        return new CloseHelp(this.gb).exec();
    }

    setLaunchUrl(data) {
        return new SetLaunchUrl(this.gb).exec(data);
    }

    setGameConfig(data) {
        return new SetGameConfig(this.gb).exec(data);
    }

    passthru(msg) {
        if (typeof msg !== "string") {
            try {
                msg.gameBridgePassthru = true;
            } catch (e) {}
        }

        logger.info("... passing to GAME", msg);
        this.gb.gameIframe.contentWindow.postMessage(msg, "*");

        try {
            this.gb.hooks.emitGameHook(msg);
        } catch (e) {
            // no hook or error in hook
        }
    }

    customMsg(msg) {
        logger.info("Custom msg to GAME", msg);
        this.gb.gameIframe.contentWindow.postMessage(msg, "*");

        try {
            this.gb.hooks.emitGameHook(msg);
        } catch (e) {
            // no hook or error in hook
        }
    }
}
